<template>
    <common-modal :showCloseIcon="false" :width="width" :height="height">
        <common-content-wrapper width="small">
            <common-content-spacer height="medium">
                <div class="modal-header">
                    <span class="modal-header--text">{{ headingText }}</span>
                </div>
                <p>{{ contentText }}</p>
                <common-buttons class="decline-modal">
                    <common-button
                        :label="decline"
                        :isSubmittable="false"
                        :isProcessing="isLoading"
                        type="primary"
                        @click="emitEvent({ name: 'decline' })"
                    ></common-button>
                    <common-button
                        :label="cancel"
                        :isSubmittable="false"
                        :isProcessing="isLoading"
                        type="secondary"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    export default {
        props: {
            decline: { type: String, default: '' },
            headingText: { type: String, default: '' },
            cancel: { type: String, default: '' },
        },
        data() {
            return {
                isLoading: false,
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .modal-header {
        display: flex;
        justify-content: center;
        align-items: center;
        &--text {
            line-height: $line-height--heading;
            font-size: 19px;
            font-weight: 700;
        }
    }

    .decline-modal {
        display: block;

        button {
            display: block;
            margin-left: 0px;
            margin-bottom: 10px;
            width: 100%;
        }
    }
</style>
